module.exports = __webpack_public_path__ + "static/img/li13_1.d9e86e45.png";